module.exports = __webpack_public_path__ + "img/784e1c501e9638255a31c12da47ac3cd.776e4538.webp";